<template>
  <div v-if="showLiveFavorites && isUS">
    <SportsFilter
      v-if="!isFavorites"
      v-show="allLiveSportIds.length > 0"
      :list="getSports"
      :selectedSport="`${sportId}`"
      @changeSport="handleChangeSport" />
    <MatchListUsComponent
      :sports="filteredSportIds"
      :matchList="filteredMatches"
      :showMarketsInMatch="showMarketsInMatch"
      :showEventCode="false"
      :showTeamIcon="showTeamIcon"
      :showFavorites="true"
      :showStatistics="showStatistics"
      :isLiveSport="true"
      :isInLivesport="isInLivesport"
      :isCategoryList="false"
      :widgetClass="'bto-sb-widget-live'"
      :loadingLive="loading"
      :matchType="'live'"
      :isLiveFavorites="isFavorites" />
  </div>
  <div
    :class="[
      'bto-sb-widget',
      'bto-sb-widget-prematch',
      { 'bto-sb-widget-prematch-full-view': viewMode === modes.multi.t },
      { 'bto-sb-widget-prematch-3w': viewMode === modes.single.t },
      'bto-sb-widget-live-now',
      { 'bto-sb-widget-overview-livenow': isOverviewProp },
    ]"
    v-else-if="showLiveFavorites">
    <WidgetHeader
      @modechanged="changeMode"
      :title="titleLive"
      :sportName="sportName"
      :showIconInTitle="isOverviewProp"
      :sportClass="sportClass" />
    <div class="bto-sb-widget-content">
      <SportList
        v-show="allLiveSportIds.length > 0"
        @changeSport="setSport"
        :selected-sport="sportId"
        :sports="allLiveSportIds" />
      <empty-state
        v-if="matches.length == 0"
        :message="emptyStateStatusMessage"
        :icon-class="emptyStateClass" />
      <component
        :is="liveComp"
        :key="liveComp"
        :matches="matches"
        :isSportTreeWay="isSportTreeWay"
        :showMarketsInMatch="showMarketsInMatch"
        :markets="markets"
        :showNoMatchesMsg="showNoMatchesMsg"
        :expandedView="viewMode === modes.single.t"
        :isOverviewProp="isOverviewProp"
        :showTeamIcon="showTeamIcon"
        :titleLive="titleLive"
        :showStatistics="showStatistics"
        :showFavorite="showFavorite"
        :showIconInTitle="showIconInTitle"
        :showAll="showAll"
        v-show="matches.length > 0" />
    </div>
  </div>
</template>
<script>
  import store from "../../../store";
  import { LiveProps } from './util/liveProps';
  import { LiveWorker } from "../../../workers";
  import { MARKET_TYPE_IDS } from "../../../models/enums/market-const";
  import WidgetHeader from './components/widget-header';
  import SportsListComponent from '../../common/match/sports-list-component';
  import LiveDefault from './components/live-default';
  import LiveExpanded from './components/live-expanded';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import MatchListUsComponent from '../../common/match-list-us-component';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import SportsFilter from "@bto-widgets/selector/web";

  export default {
    name: 'LiveNowWidget',
    data() {
      return {
        viewMode: APP_SETTINGS.settings.layout === LAYOUT_NAME.LATAM ? 'single' : 'multi',
        liveComp: APP_SETTINGS.settings.layout === LAYOUT_NAME.LATAM ? 'LiveExpanded' : 'LiveDefault',
        modes: {
          multi: { t: 'multi', comp: 'LiveDefault' },
          single: { t: 'single', comp: 'LiveExpanded' },
        },
        allLiveSportIds: [],
        liveAllMatches: [],
        sportId: 0,
        isSportTreeWay: false,
        sportClass: '',
        sportName: '',
        matches: [],
        markets: {},
        showNoMatchesMsg: false,
        emptyStateIcon: ICON_CLASS.LIVE,
        emptyStateMessage: 'Public.NoLiveMatches',
        loading: false,
        noLiveEventsTimeout: +APP_SETTINGS.settings.noLiveEventsTimeout || 0,
        loadingSpinner: ICON_CLASS.LOADING,
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
        isInLivesport: true,
        selectedSportsTab: APP_SETTINGS.settings.selectedSportsTab,
      };
    },
    props: LiveProps,
    computed: {
      filteredSportIds() {
        if (this.sportId === '0' || this.isFavorites) {
          return this.allLiveSportIds;
        }
        return this.allLiveSportIds.filter(item => item === this.sportId);
      },
      filteredMatches() {
        if (this.sportId === '0' || this.isFavorites) {
          return this.matches;
        }
        return this.matches.filter(match => match.sportId !== this.sportId);
      },
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.$translate.text('Mobile.LoadingMore') : this.$translate.text(this.emptyStateMessage);
      },
      totalPrematchFavoriteMatches() {
        return this.isFavorites ? store.state.favoritesModule.favoriteMatches.length : 0;
      },
      /**
       * Toggle live now widget
       */
      showLiveFavorites() {
        // if we are not in favorites always show
        if (!this.isFavorites) {
          return true;
        }
        const liveFavoriteSportIds = store.getters.liveFavoriteSportIds;
        // if we have favorites in multiple sports show
        if (liveFavoriteSportIds > 0) {
          return true;
        }
        // if we have live favorite matches show
        if (this.matches.length > 0) {
          return true;
        }
        // if we don't have prematch favorite matches show
        if (this.totalPrematchFavoriteMatches === 0) {
          return true;
        }
        return false;
      },
      getSports() {
        let widgetSports = [];

        let sportsIds = this.allLiveSportIds;
        let allSports = store.state.SportsModule.allSportsData;
        const sportMap = this.liveAllMatches.reduce((acc, lm) => {
          if (typeof acc[lm.sportId] === 'undefined') {
            acc[lm.sportId] = 0;
          }
          acc[lm.sportId] += 1;
          return acc;
        }, {});
        sportsIds.forEach((s) => {
          if (typeof allSports[s] !== 'undefined') {
            widgetSports.push({
              name: allSports[s].name,
              class: allSports[s].class,
              id: `${allSports[s].id}`,
              label: sportMap[s],
            });
          }
        });

        this.pushAllSportsLast(widgetSports, APP_SETTINGS.settings.showAllSportsLast);

        return widgetSports;
      },
    },
    created() {
      // if widget used for live favorites skip created hook
      if (this.isFavorites) {
        this.emptyStateIcon = ICON_CLASS.FAVORITES;
        this.emptyStateMessage = 'Mobile.NoFavoritesMessage';
        this.isInLivesport = false;
        return;
      }
      this.loading = true;
      if (!this.matches.length) {
        LiveWorker.postMessage({ ev: this.isUS ? 'allLiveMatches' : 'lSportMatches', resp: {} });
      }
      LiveWorker.addEventListener('message', this.handleLiveEvents);
      setTimeout(() => {
        this.loading = false;
      }, this.noLiveEventsTimeout * 1000);
    },
    destroyed() {
      LiveWorker.removeEventListener('message', this.handleLiveEvents);
    },
    methods: {
      handleChangeSport(sId) {
        this.sportId = sId;
      },
      handleLiveEvents(msg) {
        switch (msg.data.type) {
          case "sportIds":
            this.allLiveSportIds = msg.data.data;
            if (!this.sportId) {
              let sportId = this.allLiveSportIds.length ? this.allLiveSportIds[0] : 0;
              if (!this.isUS) {
                sportId = +sportId;
              }
              this.setSport(this.isUS && this.selectedSportsTab === "allSports" ? '0' : sportId);
            }
            break;
          case "matches":
            if (!this.isUS) {
              this.markets = msg.data.data.mr;
              this.setMatches(msg.data.data.lm);
              const sportId = msg.data.data.hasOwnProperty('sid') ? msg.data.data.sid : 0;
              this.$emit('matchesData', msg.data.data.lm, sportId);
              if (!msg.data.data.lm.length) {
                this.showNoMatchesMsg = true;
              } else {
                this.showNoMatchesMsg = false;
              }
            }
            break;
          case "matchUpdates":
            if (!this.isUS) {
              this.setMatches(msg.data.data.lm);
              this.$emit('matchesData', msg.data.data.lm, msg.data.data.sid);
            }
            break;
          case "allLiveMatches":
            if (this.isUS) {
              this.setMatchesUs(msg.data.data.lm);
            }
            break;
        }
      },
      /**
       * Change selected sport
       */
      setSport(sId) {
        if (typeof sId !== 'undefined' && this.sportId !== sId) {
          LiveWorker.postMessage({ ev: "setSportId", resp: sId });
          this.sportId = sId;
          this.sportClass = store.getters.getSportClass(this.sportId);
          this.sportName = store.getters.getSportName(this.sportId);
          this.isSportTreeWay = store.getters.getSportType(sId) === MARKET_TYPE_IDS.THREE_WAY;
        }
      },
      /**
       * Change live view mode single/multi
       * @param mode
       */
      changeMode(mode) {
        this.viewMode = mode;
        this.liveComp = this.modes[mode].comp;
      },
      setMatchesUs(matches) {
        //get matches for the sport filter before slice
        this.liveAllMatches = matches;

        if (!this.isOverviewProp && this.maxDisplayedEvents) {
          const sportMap = {};
          // Slice live matches for each sport
          this.matches = matches.reduce((acc, lm) => {
            if (!sportMap[lm.sportId]) {
              sportMap[lm.sportId] = 0;
            }
            sportMap[lm.sportId] += 1;
            if (sportMap[lm.sportId] <= this.maxDisplayedEvents) {
              acc.push(lm);
            }
            return acc;
          }, []);
          return;
        }

        this.matches = matches;
      },
      /**
       * controll the number of displayed event according to admin customizer setting
       */
      setMatches(matches) {
        if (!this.isOverviewProp && this.maxDisplayedEvents) {
          this.matches = matches.slice(0, this.maxDisplayedEvents);
          return;
        }
        this.matches = matches;
        this.loading = false;
      },
      pushAllSportsLast(array, bool) {
        const allSports = {
          name: this.$translate.text('Mobile.AllSports'),
          class: 'all-sports',
          id: '0',
          label: this.liveAllMatches.length
        };
        if(bool) {
          array.push(allSports);
        } else {
          array.unshift(allSports);
        }
      }
    },
    components: {
      WidgetHeader,
      SportList: SportsListComponent,
      LiveDefault,
      LiveExpanded,
      EmptyState,
      MatchListUsComponent,
      SportsFilter,
    }
  };
</script>
